module.exports = __webpack_public_path__ + "assets/images/medic_r.19bfdfb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/medic_r.png
// module id = 756
// module chunks = 1